import React from "react";

class Chat extends React.Component{
    render(){
        return(
            <div>
                
            </div>
        )
    }
}

export default Chat;